<template>
	<!-- 饼图  柱状图  条形图  圆环 -->
	<!-- 下拉框题 单选-->
	<div class="oneChart">
		<div class="title_box">
			<span class="title_box_span">
				<span class="textlong" :title="htmlToString(CrossTabs.name)">
					<span>{{ CrossTabs.sheet }}:</span>
					{{ htmlToString(CrossTabs.name) }}
				</span>
			</span>
			<span class="el-dropdown_button">
				
				<el-button v-if="bankAnalysis==2" plain style="margin-top: 10px; margin-right: 10px" @click="newExport(CrossTabs.id)">{{$t('DataRecycling.ExportData')}}</el-button>
				<el-button plain style="margin-top: 10px; margin-right: 10px" @click="exportExcl(CrossTabs.id)">{{$t('DataRecycling.ExportChart')}}</el-button>

				<el-select :popper-append-to-body="false" v-model="CrossTabs.chartType" :placeholder="$t('DataRecycling.PleaseSelect')" :key="CrossTabs.id" @change="selection">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</span>
		</div>
		<div class="echart" ref="echart_div"></div>
		<div class="">
			<table border="1">
				<tr v-for="(item, index) in CrossTabs.dataArrayList" :key="index" class="table_tr">
					<td v-for="(item1, index1) in item" :key="index1">{{ htmlToString(item1) }}</td>
				</tr>
				<tr>
					<td colspan="100">{{$t('DataRecycling.NumberOfRespondents')}} : {{ CrossTabs.answerNumber }}</td>
				</tr>
			</table>

			<div></div>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts';
export default {
	props: {
		CrossTabs: {
			type: Object //可指定接收类型，如:Array.
		},
		bankAnalysis: {
			type: Number //可指定接收类型，如:Number.
		},
		CrossTabsindex: {}
	},
	data() {
		return {
			wid: 0,
			barData: [], //条行图 数据
			barName: [], //条形图 名字
			pieData: [], //饼图数据
			options: [
				{
					value: '1',
					label: this.$t('DataRecycling.Pie')
				},
				{
					value: '2',
					label: this.$t('DataRecycling.Histogram')
				},
				{
					value: '3',
					label: this.$t('DataRecycling.BarChart')
				},
				{
					value: '4',
					label: this.$t('DataRecycling.Ring')
				}
			]
		};
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || 0;
		this.loadData();
		console.log('CrossTabs', this.CrossTabs);
	},
	methods: {
		newExport(id){
			this.$emit('newExport',id)
		},
		exportExcl(qid) {
			console.log('CrossTabs', this.CrossTabs);
			var id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportTopicStatistics}?id=${id}&state=0&Authorization=Bearer${window.localStorage.getItem('token')}&qid=${qid}&isbank=${
					that.CrossTabs.isbank
				}`,
				method: 'Get',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},		
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		selection(val) {
			this.barData = [];
			this.barName = [];
			this.pieData = [];
			if (val == 1) {
				this.pie();
			}
			if (val == 2) {
				this.histogram();
			}
			if (val == 3) {
				this.longBar();
			}
			if (val == 4) {
				this.annulus();
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setStatisticalStyle}`,
				method: 'POST',
				data: {
					id: that.CrossTabs.id,
					chartType: val,
					isBank: that.CrossTabs.isbank
				},
				cb(res) {
					if (res.code == 0) {
					}
				}
			};
			this.$util.request(params);
		},
		// 饼图
		pie() {
			if (this.CrossTabs.questionsType == 11 || this.CrossTabs.questionsType == 38) {
				let targetArr = [];
				this.CrossTabs.dataArrayList.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v);
						} else {
							targetArr[i] = [v];
						}
					});
				});

				for (let i = 0; i < targetArr.length - 1; i++) {
					let temporary = {};
					temporary.value = targetArr[i][1];
					let temporaryName = '';
					temporaryName = targetArr[i][0];
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					temporary.name = temporaryName;
					this.pieData.push(temporary);
				}
			} else {
				let temporaryData = this.CrossTabs.dataArrayList;
				for (let i = 1; i < temporaryData.length; i++) {
					let temporary = {};
					temporary.value = temporaryData[i][1];
					let temporaryName = '';
					temporaryName = temporaryData[i][0];
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					temporary.name = temporaryName;
					this.pieData.push(temporary);
				}
			}
			// if (!this.CrossTabs.options.title.text) return '';
			// if (this.CrossTabs.options.title.text.length > 20) {
			// 	this.CrossTabs.options.title.text = this.CrossTabs.options.title.text.slice(0, 20) + '...';
			// }
			let name = '';
			let title = '';
			if (this.CrossTabs.options.title) {
				name = this.CrossTabs.options.title.text;
				title = this.CrossTabs.options.title;
			} else {
				name = '';
				title = '';
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				title: title,
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: 'left'
				},
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				series: [
					{
						name: name,
						type: 'pie',
						radius: '50%',
						data: this.pieData,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};

			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 圆环图
		annulus() {
			if (this.CrossTabs.questionsType == 11 || this.CrossTabs.questionsType == 38) {
				let targetArr = [];
				this.CrossTabs.dataArrayList.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v);
						} else {
							targetArr[i] = [v];
						}
					});
				});

				for (let i = 0; i < targetArr.length - 1; i++) {
					let temporary = {};
					temporary.value = targetArr[i][1];
					temporary.name = this.htmlToString(targetArr[i][0]);
					if (!temporary.name) return '';
					if (temporary.name.length > 10) {
						temporary.name = temporary.name.slice(0, 10) + '...';
					}
					this.pieData.push(temporary);
				}
			} else {
				let temporaryData = this.CrossTabs.dataArrayList;
				for (let i = 1; i < temporaryData.length; i++) {
					let temporary = {};
					temporary.value = temporaryData[i][1];
					temporary.name = this.htmlToString(temporaryData[i][0]);
					if (!temporary.name) return '';
					if (temporary.name.length > 10) {
						temporary.name = temporary.name.slice(0, 10) + '...';
					}

					this.pieData.push(temporary);
				}
			}
			console.log(this.CrossTabs.options);
			let name = '';
			let title = '';
			if (this.CrossTabs.options.title) {
				name = this.CrossTabs.options.title.text;
				title = this.CrossTabs.options.title;
			} else {
				name = '';
				title = '';
			}
			
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					top: '5%',
					left: 'center'
				},
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				series: [
					{
						name:  name,
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: this.pieData
					}
				]
			};

			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 柱状图
		histogram() {
			if (this.CrossTabs.questionsType == 11 || this.CrossTabs.questionsType == 38) {
				let targetArr = [];
				this.CrossTabs.dataArrayList.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v);
						} else {
							targetArr[i] = [v];
						}
					});
				});
				for (let i = 0; i < targetArr.length - 1; i++) {
					let temporaryName = '';
					temporaryName = this.htmlToString(targetArr[i][0]);
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					this.barData.push(targetArr[i][1]);
					this.barName.push(temporaryName);
				}
				console.log(this.barName);
			} else {
				let temporary = this.CrossTabs.dataArrayList;
				for (let i = 1; i < temporary.length; i++) {
					let temporaryName = '';
					temporaryName = this.htmlToString(temporary[i][0]);
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					this.barData.push(temporary[i][1]);
					this.barName.push(temporaryName);
				}
			}

			// console.log(this.barName)

			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				xAxis: {
					type: 'category',
					data: this.barName,
					axisLabel: {
						show: true,                               
						textStyle: {
							color: '#595C61'
						},
					}
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						data: this.barData,
						type: 'bar'
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 条形图
		longBar() {
			if (this.CrossTabs.questionsType == 11 || this.CrossTabs.questionsType == 38) {
				let targetArr = [];
				this.CrossTabs.dataArrayList.forEach((val, index) => {
					val.forEach((v, i) => {
						if (targetArr[i]) {
							targetArr[i].push(v);
						} else {
							targetArr[i] = [v];
						}
					});
				});
				for (let i = 0; i < targetArr.length - 1; i++) {
					let temporaryName = '';
					temporaryName = this.htmlToString(targetArr[i][0]);
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					this.barData.push(targetArr[i][1]);
					this.barName.push(temporaryName);
				}
			} else {
				let temporary = this.CrossTabs.dataArrayList;
				for (let i = 1; i < temporary.length; i++) {
					let temporaryName = '';
					temporaryName = this.htmlToString(temporary[i][0]);
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					this.barData.push(temporary[i][1]);
					this.barName.push(temporaryName);
				}
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				yAxis: {
					type: 'category',
					data: this.barName
				},
				xAxis: {
					type: 'value'
				},
				series: [
					{
						data: this.barData,
						type: 'bar'
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		//初始化
		loadData() {
			// 取饼图  圆环图数据
			this.selection(this.CrossTabs.chartType||'2');
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.oneChart {
	.title_box {
		width: 100%;
		height: 56px;
		background: #f9fcff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.title_box_span {
			margin-left: 25px;
			font-size: 14px;
			color: #000;
			font-family: Microsoft YaHei;
			width: calc(100% - 300px);
		}
		.el-dropdown_button {
			float: right;
			margin-right: 20px;
		}
	}
	.echart {
		width: 90%;
		height: 400px;
		margin: 20px auto;
	}
	table {
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;
	}

	table tr td {
		padding: 8px 0 8px 10px;
	}
}
</style>
